import { clsx } from 'clsx'

export function Prose(props) {

  const { as: Component = 'div', className = '', ...extraProps } = props
  return (
    <Component
      className={clsx(
        className,
        'prose prose-portal max-w-none dark:prose-invert dark:text-portal-400 pb-16',
        // headings
        'prose-headings:scroll-mt-6 prose-headings:font-display prose-headings:font-normal lg:prose-headings:scroll-mt-[1.5rem]',
        // lead
        'prose-lead:text-portal-500 dark:prose-lead:text-portal-400',
        // links
        'prose-a:text-consumer-blue prose-a:hover:text-neutral-80 dark:prose-a:text-dark-consumer-blue dark:prose-a:hover:text-neutral-30',
        // pre
        'prose-pre:rounded prose-pre:mx-6 prose-pre:bg-portal-900 dark:prose-pre:bg-portal-800/60 dark:prose-pre:ring-1 dark:prose-pre:ring-slate-300/10',
        // hr
        'dark:prose-hr:border-portal-800',
        // paragraphs
        'prose-p:text-body1',
        
        // TABLE
        'prose-table:w-full prose-table:border-collapse prose-table:border-neutral-20 prose-table:dark:border-neutral-80 prose-table:text-body2',
        // thead
        'prose-thead:border-b-2 prose-thead:border-neutral-20 prose-thead:dark:border-neutral-80 prose-thead:align-middle',
        // th
        'prose-th:font-bold prose-th:text-left prose-th:py-2.5 prose-th:px-3 prose-th:bg-neutral-10 dark:prose-th:bg-neutral-90 prose-th:border-r-1 prose-th:last:border-r-0 prose-th:border-neutral-20 prose-th:dark:border-neutral-80',
        // td
        'prose-td:py-2.5 prose-td:px-3 prose-td:align-middle prose-td:border-r-1 prose-td:last:border-r-0 prose-td:border-neutral-20 prose-td:dark:border-neutral-80',
        // tr
        'prose-tr:border-b-1 prose-tr:border-neutral-20 prose-tr:dark:border-neutral-80 prose-tr:odd:bg-neutral-05 dark:prose-tr:odd:bg-neutral-95',
        // paragraphs
        '[&_table_p]:text-body2 [&_table_p]:my-0',
        // quotes
        '[&_table_blockquote_p]:text-body3 [&_table_blockquote]:mt-2 [&_table_blockquote]:mb-0 [&_table_blockquote]:border-neutral-30 [&_table_blockquote]:dark:border-neutral-80'
      )}
      {...extraProps}
    />
  )
}